<template>
  <div
    class="list-skeleton"
    role="status"
    aria-label="Загрузка списка"
    :style="{ '--skeleton-columns': columns }"
  >
    <div class="list-skeleton__header">
      <span v-for="column in columns" :key="`header-${column}`" />
    </div>
    <div v-for="row in rows" :key="row" class="list-skeleton__row">
      <span
        v-for="column in columns"
        :key="`${row}-${column}`"
        :style="{ width: columnWidth(column, row) }"
      />
    </div>
    <span class="sr-only">Загрузка...</span>
  </div>
</template>

<script>
export default {
  name: 'ListSkeleton',
  props: {
    rows: { type: Number, default: 7 },
    columns: { type: Number, default: 4 },
  },
  methods: {
    columnWidth(column, row) {
      const widths = ['72%', '88%', '61%', '78%', '54%'];
      return widths[(column + row) % widths.length];
    },
  },
};
</script>

<style lang="scss" scoped>
.list-skeleton {
  margin: 20px 0;
  overflow: hidden;
  border: 1px solid #eaecf0;
  border-radius: 10px;
}

.list-skeleton__header,
.list-skeleton__row {
  display: grid;
  grid-template-columns: repeat(var(--skeleton-columns), minmax(0, 1fr));
  align-items: center;
  gap: 28px;
  padding: 14px;
}

.list-skeleton__header {
  background: #f9fafb;
}

.list-skeleton__row {
  min-height: 58px;
  border-top: 1px solid #eef0f3;
}

.list-skeleton__header span,
.list-skeleton__row span {
  display: block;
  height: 11px;
  border-radius: 6px;
  background: linear-gradient(90deg, #eef0f3 25%, #f8f9fb 50%, #eef0f3 75%);
  background-size: 220% 100%;
  animation: skeleton-shimmer 1.35s ease-in-out infinite;
}

.list-skeleton__header span {
  width: 52%;
  height: 9px;
}

@keyframes skeleton-shimmer {
  from {
    background-position: 100% 0;
  }

  to {
    background-position: -100% 0;
  }
}

@media (prefers-reduced-motion: reduce) {
  .list-skeleton__header span,
  .list-skeleton__row span {
    animation: none;
  }
}
</style>
